const json = {
    GE: {
        NAVIGATIONS: [
            'გაზიარებული ემოციები',
            'რიცხვები და ემოციები',
            'კამპანიის შესახებ',
            'შედი Georgia Travel-ზე'
        ],
        MY_BOOK: 'ჩემი წიგნი',
        LOG_OUT: 'გამოსვლა'
    },
    EN: {
        NAVIGATIONS: [
            'Shared Emotions',
            'Figures & Feelings',
            'About',
            'Go to Georgia Travel'
        ],
        MY_BOOK: 'My book',
        LOG_OUT: 'Log out'
    }
}

export default json



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.texts.js